// extracted by css-extract-rspack-plugin
export default {"userInfo":"EmailAuthUserBarItem_userInfo___J4qX","email":"EmailAuthUserBarItem_email__mGwYG"};